'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: auto;\n  background-color: transparent;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: auto;\n  background-color: transparent;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 5;\n  overflow-y: auto;\n\n  @media (orientation: portrait) {\n    justify-content: flex-start;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 5;\n  overflow-y: auto;\n\n  @media (orientation: portrait) {\n    justify-content: flex-start;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  @media(orientation: portrait) {\n    display: block;\n    text-align: center;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  @media(orientation: portrait) {\n    display: block;\n    text-align: center;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-basis: 30vw;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  justify-content: space-between;\n\n  @media(oreintation: portrait) {\n    display: block;\n    text-align: center;\n  }\n\n  img { flex-shrink: 0 }\n\n  a { margin: 1rem;}\n'], ['\n  display: flex;\n  flex-basis: 30vw;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  justify-content: space-between;\n\n  @media(oreintation: portrait) {\n    display: block;\n    text-align: center;\n  }\n\n  img { flex-shrink: 0 }\n\n  a { margin: 1rem;}\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  justify-self: flex-start;\n  align-self: flex-start;\n  width: 30vw;\n\n  @media(orientation: portrait) {\n    width: 90vw;\n    margin: 0 auto;\n  }\n'], ['\n  justify-self: flex-start;\n  align-self: flex-start;\n  width: 30vw;\n\n  @media(orientation: portrait) {\n    width: 90vw;\n    margin: 0 auto;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  justify-self: flex-start;\n  align-self: flex-start;\n  height: 40vh;\n  margin: 0 auto;\n  background-color: rgba(255,255,255,0.4);\n\n  @media(orientation: portrait) {\n    width: 90vw;\n    margin: 0 auto;\n  }\n'], ['\n  justify-self: flex-start;\n  align-self: flex-start;\n  height: 40vh;\n  margin: 0 auto;\n  background-color: rgba(255,255,255,0.4);\n\n  @media(orientation: portrait) {\n    width: 90vw;\n    margin: 0 auto;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  background-color: rgba(255,255,255,0.4);\n  width: 70vw;\n\n  @media (orientation: portrait) {\n    width: 90vw;\n  }\n'], ['\n  background-color: rgba(255,255,255,0.4);\n  width: 70vw;\n\n  @media (orientation: portrait) {\n    width: 90vw;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _stage = require('../stage/stage');

var _stage2 = _interopRequireDefault(_stage);

var _terms = require('../terms/terms');

var _terms2 = _interopRequireDefault(_terms);

var _paypalButton = require('../paypal-button/paypal-button');

var _paypalButton2 = _interopRequireDefault(_paypalButton);

var _fundraisingVideoButton = require('./fundraising-video-button');

var _fundraisingVideoButton2 = _interopRequireDefault(_fundraisingVideoButton);

var _exhibitorButton = require('./exhibitor-button');

var _exhibitorButton2 = _interopRequireDefault(_exhibitorButton);

var _directToShowButton = require('./direct-to-show-button');

var _directToShowButton2 = _interopRequireDefault(_directToShowButton);

var _giftCardListButton = require('./gift-card-list-button');

var _giftCardListButton2 = _interopRequireDefault(_giftCardListButton);

var _groupPurchase = require('./group-purchase');

var _groupPurchase2 = _interopRequireDefault(_groupPurchase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrap = _styledComponents2.default.div(_templateObject);

var Wrapper = _styledComponents2.default.div(_templateObject2);

var Row = _styledComponents2.default.div(_templateObject3);

var Col = _styledComponents2.default.div(_templateObject4);

var Logo = _styledComponents2.default.img(_templateObject5);

var Package = _styledComponents2.default.img(_templateObject6);

var Frost = _styledComponents2.default.div(_templateObject7);

/** @class Fundraising
  * A component to allow purchasing a
  * gift card package from a fundraising
  * affiliate - either a specified one, or
  * a list of options.
  * @prop {string} name - the name of the expo show
  * @prop {url} image - the fundraising promo image
  * @prop {url} video - the fundraising promo video
  * @prop {array} deals - an array of deal objects
  * @prop {bool} stage - the stage to render as a background
  * @prop {string} expoID - the id of the expo
  * @prop {string} showID - the id of the show
  * @prop {array} beneficiaries (optional) - a list of benefitting organizations
  * @prop {string} token (optional) - a unique token identifying
  * a particular fundraising affiliate
  */

var Fundraising = function (_Component) {
  _inherits(Fundraising, _Component);

  function Fundraising() {
    _classCallCheck(this, Fundraising);

    return _possibleConstructorReturn(this, (Fundraising.__proto__ || Object.getPrototypeOf(Fundraising)).apply(this, arguments));
  }

  _createClass(Fundraising, [{
    key: 'render',

    /** @method render
      * Renders the component
      */
    value: function render() {
      var stage = this.props.stage ? _react2.default.createElement(_stage2.default, this.props.stage) : '';
      var purchase = this.props.token ? _react2.default.createElement(_groupPurchase2.default, {
        name: this.props.name,
        token: this.props.token,
        expoID: this.props.expoID,
        showID: this.props.showID
      }) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(Package, { src: this.props.image }),
        _react2.default.createElement(_paypalButton2.default, { size: 'large',
          expoName: this.props.name,
          expoID: this.props.expoID,
          showID: this.props.showID
        })
      );
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          Wrapper,
          null,
          _react2.default.createElement(
            Row,
            null,
            _react2.default.createElement(Logo, { src: this.props.logo }),
            _react2.default.createElement(_fundraisingVideoButton2.default, { video: this.props.video })
          ),
          _react2.default.createElement(
            Row,
            null,
            _react2.default.createElement(
              Col,
              null,
              _react2.default.createElement(_giftCardListButton2.default, { name: this.props.name, deals: this.props.deals, beneficiaries: this.props.beneficiaries }),
              _react2.default.createElement(_directToShowButton2.default, null)
            ),
            _react2.default.createElement(
              Col,
              null,
              purchase
            )
          ),
          _react2.default.createElement(
            Frost,
            null,
            _react2.default.createElement(_terms2.default, { name: this.props.name, supportEmail: this.props.supportEmail })
          )
        ),
        stage
      );
    }
  }]);

  return Fundraising;
}(_react.Component);

exports.default = Fundraising;


Fundraising.propTypes = {
  name: _propTypes2.default.string.isRequired,
  image: _propTypes2.default.string.isRequired,
  video: _propTypes2.default.string.isRequired,
  deals: _propTypes2.default.array.isRequired,
  stage: _propTypes2.default.object.isRequired,
  expoID: _propTypes2.default.string.isRequired,
  showID: _propTypes2.default.string.isRequired,
  beneficiaries: _propTypes2.default.object.isRequired,
  token: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/fundraising/fundraising.js
// module id = 1382
// module chunks = 0